<template>
    <div :class="{
        'nav-container': true,
        open: navigationOpen,
        closed: !navigationOpen,
        'nav-container-mobile': mobile
    }">
        <a v-if="mobile" class="boyden-logo" href="/boyden">
            <img src="@/assets/logos/logo.png" />
        </a>
        <nav :class="{ sidebar: true }">
            <o-tooltip variant="default" :triggers="['click']" :auto-close="['outside', 'escape']" position="auto" multiline size="large" class="sidebar-item">
                <template #content>
                    <div class="apps">
                        <a :href="$filters.InveniasBaseUrl()" target="_blank">
                            <img src="@/assets/icons/app-invenias.png" />
                            <div>Invenias</div>
                        </a>
                        <a href="/boyden/technology/kaiya-ai" target="_blank" class="logo-btn">
                            <img src="@/assets/icons/app-kaiya.png" style="background-color: steelblue; padding: 6px; border-radius: 6px; " />
                            <div>Kaiya AI</div>
                        </a>
                        <a href="https://boyden.box.com" target="_blank">
                            <img src="@/assets/icons/app-box.png" />
                            <div>Box</div>
                        </a>
                        <a href="/boyden/technology/mail" target="_blank">
                            <img src="@/assets/icons/app-outlook.png" />
                            <div>Mail</div>
                        </a>
                        <a href="https://teams.microsoft.com" target="_blank">
                            <img src="@/assets/icons/app-teams.png" />
                            <div>Teams</div>
                        </a>
                        <a href="/boyden/technology/mail/spam-filter" target="_blank" class="logo-btn">
                            <img src="@/assets/icons/app-barracuda.png" />
                            <div>Barracuda</div>
                        </a>
                        <a href="https://www.linkedin.com/" target="_blank">
                            <img src="@/assets/icons/app-linkedin.png" />
                            <div>LinkedIn</div>
                        </a>
                        <a href="https://www.zoominfo.com/" target="_blank">
                            <img src="@/assets/icons/app-zoom-info.png" />
                            <div>ZoomInfo</div>
                        </a>

                        <a href="/boyden/technology/avs-cloud-services/source-whale" target="_blank">
                            <img src="@/assets/icons/app-source-whale.png" />
                            <div>SourceWhale</div>
                        </a>
                        <a href="https://secure.echosign.com/public/login" target="_blank">
                            <img src="@/assets/icons/app-adobe-sign.png" />
                            <div>Adobe Sign</div>
                        </a>
                        
                        <a href="https://deepnet.boyden.com:8076/dsc" target="_blank">
                            <img src="@/assets/icons/app-deepnet.png" />
                            <div>Security</div>
                        </a>

                        <a href="/boyden/technology/avs-cloud-services/coral-starfish" target="_blank" class="logo-btn">
                            <img src="@/assets/icons/app-coralstarfish.png" />
                            <div>Coral Starfish</div>
                        </a>
                    </div>
                </template>

                <span class="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 6C13.6569 6 15 4.65685 15 3C15 1.34315 13.6569 0 12 0C10.3431 0 9 1.34315 9 3C9 4.65685 10.3431 6 12 6Z" fill="currentColor" />
                        <path d="M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z" fill="currentColor" />
                        <path d="M21 6C22.6569 6 24 4.65685 24 3C24 1.34315 22.6569 0 21 0C19.3431 0 18 1.34315 18 3C18 4.65685 19.3431 6 21 6Z" fill="currentColor" />
                        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" fill="currentColor" />
                        <path d="M3 15C4.65685 15 6 13.6569 6 12C6 10.3431 4.65685 9 3 9C1.34315 9 0 10.3431 0 12C0 13.6569 1.34315 15 3 15Z" fill="currentColor" />
                        <path d="M21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9C19.3431 9 18 10.3431 18 12C18 13.6569 19.3431 15 21 15Z" fill="currentColor" />
                        <path d="M12 24C13.6569 24 15 22.6569 15 21C15 19.3431 13.6569 18 12 18C10.3431 18 9 19.3431 9 21C9 22.6569 10.3431 24 12 24Z" fill="currentColor" />
                        <path d="M3 24C4.65685 24 6 22.6569 6 21C6 19.3431 4.65685 18 3 18C1.34315 18 0 19.3431 0 21C0 22.6569 1.34315 24 3 24Z" fill="currentColor" />
                        <path d="M21 24C22.6569 24 24 22.6569 24 21C24 19.3431 22.6569 18 21 18C19.3431 18 18 19.3431 18 21C18 22.6569 19.3431 24 21 24Z" fill="currentColor" />
                    </svg>
                </span>
                <label>Apps</label>
            </o-tooltip>
            <router-link v-for="item in sidebarOptions" :key="item" :to="{ name: item.VueRouterName }" :class="{
                'sidebar-item': true,
                'sidebar-item_active': item.VueRouterPath === currentRoot
            }">
                <template v-if="item._icon">
                    <o-icon v-if="item._icon.type === 'fas'" :icon="item._icon.name" :pack="item._icon.type"></o-icon>
                    <span v-else class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" stroke="currentColor" fill="none">
                            <circle cx="15" cy="15" r="12" stroke-width="4.5" />
                        </svg>
                    </span>
                    <label>{{ item.Title }}</label>
                </template>
            </router-link>
            <a v-if="isAdmin && !mobile" class="sidebar-item sidebar-item_end" @click="toggleAdminTray">
                <o-icon icon="user-chart" pack="fas"></o-icon>
                <label>Admin</label>
            </a>
        </nav>
        <nav class="navbar" v-if="!hideNav">
            <a v-if="!mobile" class="boyden-logo" href="/boyden">
                <img src="@/assets/logos/logo.png" />
            </a>

            <div class="wrapper" ref="wrapper">
                <o-button variant="success" inverted class="thin" size="small" @click="OpenAddPage" style="margin-left: 1rem" v-if="isEditing && !isAdminPage">
                    New page
                </o-button>
                <div class="shadow shadow-top" ref="shadowTop"></div>
                <div class="shadow shadow-bottom" ref="shadowBottom"></div>
                <div class="routes-container" @scroll="OnScroll" ref="routesContainer">
                    <nav-section v-for="item in currentNavOptions" :key="item.name" :primeRoute="item" @change="OnChange" @push="BubblePush"></nav-section>
                </div>
            </div>
            <admin-tray v-if="adminTrayIsOpen">
                <o-button @click="GoTo('_adminRoutes')" variant="light">Routes</o-button>
                <o-button @click="GoTo('_adminFiles')" variant="light">Files</o-button>
                <o-button @click="GoTo('_adminImages')" variant="light">Images</o-button>
                <o-button @click="toggleEditMode" variant="primary" :key="isEditing" :disabled="isAdminPage">
                    Turn editing
                    <b>{{ isEditing ? "OFF" : "ON" }}</b>
                </o-button>
            </admin-tray>
        </nav>
    </div>
</template>
<script>
    import {
        ref,
        computed,
        watch,
        onMounted,
        inject,
        nextTick,
        onBeforeUnmount,
        markRaw
    } from "vue";
    import { getRoutes, getPathArray, PrimeRouteRecord, refreshRoutes, sortRoutesByTreeOrder } from "@/services/routeSetup";
    import navSection from "@/components/navbar/navSection.vue";
    import adminTray from "@/components/navbar/adminTray.vue";
    import editPageModal from "@/components/modals/editPageModal.vue";
    import { useRoute, useRouter } from "vue-router";
    import store from "@/store";

    export default {
        emits: ["change", "push"],
        props: {
            hideNav: {
                type: Boolean,
                default: false
            },
            navigationOpen: {
                type: Boolean,
                default: true
            },
            mobile: {
                type: Boolean,
                default: false
            }
        },
        components: {
            "nav-section": navSection,
            "admin-tray": adminTray
        },
        setup(props, context) {
            const oruga = inject("$oruga");
            const $http = inject("$http");
            const $error = inject("$error");
            const $route = useRoute();
            const $router = useRouter();

            const api = ref(process.env.VUE_APP_API);

            const isAdmin = computed(() => {
                return store.getters.isAdmin;
            });

            const isEditing = computed(() => {
                return store.getters.isEditing;
            });

            const routesContainer = ref(null);
            const wrapper = ref(null);
            const shadowTop = ref(null);
            const shadowBottom = ref(null);

            const OnScroll = (e) => {
                const isClipping = routesContainer.value.scrollHeight - wrapper.value.offsetHeight;
                const contentScrollHeight = routesContainer.value.scrollHeight - wrapper.value.offsetHeight;
                const currentScroll = routesContainer.value.scrollTop / contentScrollHeight;
                if (contentScrollHeight > 0) {
                    shadowTop.value.style.opacity = Math.ceil(currentScroll);
                    shadowBottom.value.style.opacity = Math.ceil(1 - currentScroll);
                } else {
                    shadowTop.value.style.opacity = 0;
                    shadowBottom.value.style.opacity = 0;
                }
            };

            const OnChange = () => {
                OnScroll();
                context.emit("change");
            };

            const BubblePush = () => {
                context.emit("push");
            };

            const toggleAdmin = () => {
                store.dispatch("toggleAdmin");
            };
            const interval = null;
            const toggleEditMode = () => {
                store.dispatch("toggleEditing");
            };

            const adminTrayToggle = ref(false);
            const toggleAdminTray = () => {
                adminTrayToggle.value = !adminTrayToggle.value;
            };
            const adminTrayIsOpen = computed(() => {
                return isAdminPage.value || (adminTrayToggle.value && isAdmin.value);
            });
            const isAdminPage = computed(() => {
                return currentRoot.value === "admin";
            });

            //getRoutes(); //Unnecessary
            const sidebarOptions = computed(() => {
                if (store.getters.routes === undefined) return [];
                return store.getters.routes.filter((o) => {
                    return o.VueRouterPath !== "" && !o.ExcludeFromNav && o.ExcludeFromNav !== true;
                });
            });

            const pathArray = computed(() => {
                return getPathArray($route);
            });

            const currentRoot = computed(() => {
                return pathArray.value[0];
            });

            const currentNavOptions = computed(() => {
                const currentRoute = $router.currentRoute.value;
                const rootPath = "/" + currentRoute.path.slice(1).split("/")[0];
                const children = sortRoutesByTreeOrder(
                    $router.getRoutes().filter(
                        (x) =>
                            x.path.startsWith(rootPath) &&
                            x.path !== rootPath &&
                            x.path.split("/").length <= 3 &&
                            !x.path.includes(":") &&
                            !x.meta.excludeFromNav
                    )
                );

                return children || [];
            });

            const GoTo = (name) => {
                sessionStorage.setItem("admin_route_focus", JSON.stringify($route.path.split("/")));
                $router.push({ name: name });
            };

            const GetAllRoutes = async () => {
                try {
                    const response = await $http.get("api/v2/routes/all");
                    return response.data;
                } catch (err) {
                    console.error(err);
                    return null;
                }
            };

            const SaveRoute = async (route) => {
                try {
                    const response = await $http.post("/api/v2/routes", route);
                    route.UUID = response.data.UUID;
                } catch (err) {
                    console.error(err);
                    $error("Failed to save route.");
                }
            };

            const OpenAddPage = () => {
                const newRoute = {
                    BreadcrumbTitle: "",
                    ExcludeFromNav: false,
                    DoNotOpen: false,
                    DoNotLink: false,
                    Title: "",
                    VueRouterName: "",
                    VueRouterPath: "",
                    RedirectLink: ""
                };

                oruga.modal.open({
                    component: markRaw(editPageModal),
                    trapFocus: true,
                    props: {
                        metadata: newRoute
                    },
                    events: {
                        save: async (result) => {
                            const parent = store.getters.routes.find((r) => r.VueRouterName === currentRoot.value);
                            if (!parent) {
                                $error("This root does not exist.");
                            } else {
                                result.metadata.Parent = { UUID: parent.UUID };
                                await SaveRoute(result.metadata);
                                await refreshRoutes();
                                result.close();
                            }
                        }
                    }
                });
            };

            watch(
                () => $router.currentRoute,
                () => {
                    store.dispatch("setPath", $route.path);
                },
                { deep: true }
            );

            return {
                api,
                isAdmin,
                isEditing,
                toggleAdmin,
                toggleEditMode,
                toggleAdminTray,
                adminTrayIsOpen,
                pathArray,
                sidebarOptions,
                currentNavOptions,
                currentRoot,
                routesContainer,
                wrapper,
                shadowTop,
                shadowBottom,
                isAdminPage,
                GoTo,
                OpenAddPage,
                OnScroll,
                OnChange,
                BubblePush
            };
        }
    };
</script>
<style lang="scss" scoped>
    @use "@/assets/css/globalVars.scss" as *;

    .apps {
        display: flex;
        flex-wrap: wrap;
        /*justify-content: space-between;*/
        justify-content: flex-start;
        gap: 10px;
        margin: 15px 10px;
        column-gap: 23px;
    }

    .apps>a {
        display: block;
        padding: 10px 25px;
        border: solid 1px #eee;
        flex-basis: 140px;
        color: $boyden-gray;
    }

    .wrapper {
        position: relative;
        overflow: hidden;
    }

    .shadow {
        position: absolute;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 0.8rem;
        pointer-events: none;
    }

    .shadow-top {
        top: 0;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.15), transparent);
        opacity: 0;
    }

    .shadow-bottom {
        bottom: 0;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), transparent);
    }

    .routes-container {
        @include no-scrollbar;
        overflow-y: auto;
        height: 100%;
        margin-bottom: auto;
    }

    .nav-container {
        display: flex;
    }

    .nav-container-mobile {
        flex-direction: column;

        .boyden-logo img {
            margin-bottom: $margin-element-large;
            margin-top: $margin-element-large;
        }

        & nav.navbar {
            width: 100%;
            grid-template-columns: 1fr;
            grid-template-rows: auto auto;
        }

        & nav.sidebar {
            flex-direction: row;
            row-gap: $margin-element-tiny;
            flex-wrap: wrap;
            align-items: center;
            height: unset;
            width: 100%;
            padding: $margin-element-tiny;

            & .sidebar-item {
                width: 4rem;
            }
        }
    }

    nav {
        @include reset-element;
        @include flex-column;

        max-height: 100vh;

        &.navbar {
            //@include no-scrollbar;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto 1fr auto;

            position: relative;
            grid-area: navbar;
            width: $nav-width;
            background-color: #fff;

            //overflow-y: auto;
            height: 100vh;
            gap: 0;
        }

        &.sidebar {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: $margin-element-large;
            width: $sidebar-width;
            grid-area: sidebar;
            padding: $margin-element-tiny;
            padding-top: $margin-element-huge;
            background-color: $color-secondary;
            font-size: 1.6em;
            color: white;

            & .sidebar-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                background-color: rgba(255, 255, 255, 0);
                border-radius: 0.7em;
                width: 100%;
                padding: $margin-element-tiny;
                height: 2.35em;
                color: rgba(255, 255, 255, 0.8);

                cursor: pointer;

                &>label {
                    margin-bottom: -0.2rem;
                    line-height: 1.8;
                    pointer-events: none;
                }

                &:deep(.tooltip-trigger) {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }

                &:deep(.tooltip-content) {
                    top: -1.3rem;
                    left: $sidebar-width;
                }

                & label {
                    font-weight: 600;
                    font-size: 0.5em;
                    margin: 0;
                }

                &:hover,
                &.sidebar-item_active {
                    color: rgba(255, 255, 255, 1);
                }

                &.sidebar-item_active {
                    background-color: rgba(255, 255, 255, 0.25);
                }

                &:hover {
                    background-color: rgba(255, 255, 255, 0.05);
                }

                &.sidebar-item_end {
                    margin-top: auto;
                }

                //Apps
                &.b-tooltip>.tooltip-trigger>.icon {
                    position: relative;
                    top: 0.1rem;
                }
            }
        }
    }

    .boyden-logo {
        line-height: 0;
        background-color: #fff;

        & img {
            display: block;
            margin: $margin-body-small auto;
            width: $logo-width;
        }
    }

    a.logo-btn {
        display: grid;

        & > img {
            margin-top: auto;
        }

        & > div {
            align-content: end;
        }
    }
</style>
